export function toBool(v: unknown): boolean {
  if (typeof v === "boolean") return v;
  if (v == null) return false;
  if (typeof v === "number") return v !== 0;
  if (typeof v === "string") {
    return ["1", "true", "t", "y", "yes"].includes(v.trim().toLowerCase());
  }
  return false;
}

